{
  "version": 1,
  "asset_id": "0ccea633-4db7-43db-b81d-7b884f793b32",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/0ccea633-4db7-43db-b81d-7b884f793b32/author-jan-jaap-bolkesteijn.webp",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/0ccea633-4db7-43db-b81d-7b884f793b32/author-jan-jaap-bolkesteijn.webp",
  "original_filename": "author-jan-jaap-bolkesteijn.webp",
  "size": 22800,
  "content_type": "image/webp",
  "created_at": "2026-08-30T14:14:46Z"
}
